var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ChildHeader from "./Child/ChildHeader";
import ChildEditModal from "./Child/ChildEditModal";
import { Anchor, Breadcrumbs, Text } from "@mantine/core";
import ChildDeleteModal from "./Child/ChildDeleteModal";
import { WordCardList } from "./Child/WordCardList";
export default function ChildDetails() {
    var params = useParams();
    var _a = useState(null), child = _a[0], setChild = _a[1];
    var navigate = useNavigate();
    var _b = useState(params.id === 'new'), editing = _b[0], setEditing = _b[1];
    var _c = useState(false), deleting = _c[0], setDeleting = _c[1];
    useEffect(function () {
        if (params.id === 'new') {
            setChild({
                uuid: '',
                name: '',
                birthday: '',
                speechItems: [],
            });
            return;
        }
        fetch('/api/child/' + encodeURIComponent(params.id))
            .then(function (res) {
            if (res.status === 401) {
                navigate('/login');
                return;
            }
            if (res.status === 404) {
                navigate('/404');
                return;
            }
            res.json().then(function (res) { return setChild(res); });
        });
    }, [params.id]);
    var updateChild = function (values) {
        setChild(__assign(__assign({}, child), { name: values.name, birthday: values.birthday }));
    };
    var cancelEdit = function (cancel) {
        setEditing(false);
        if (cancel === true && params.id === 'new') {
            navigate('/children');
        }
    };
    if (child === null) {
        return _jsx("div", {});
    }
    return _jsxs("div", { children: [_jsx(Breadcrumbs, { children: [
                    _jsx(Text, { size: "sm", c: "dimmed", children: "Home" }, 0),
                    _jsx(Anchor, { size: "sm", href: "/children", children: "Children" }, 1)
                ] }), _jsx(ChildHeader, { child: child, onEdit: function () { return setEditing(true); }, onDelete: function () { return setDeleting(true); } }), _jsx(ChildEditModal, { child: child, show: editing, onSave: updateChild, onClose: cancelEdit }), _jsx(ChildDeleteModal, { child: child, show: deleting, onClose: function () { return setDeleting(false); } }), _jsx(WordCardList, { child: child })] });
}
